import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import About from "../components/About";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Products from "../components/Products";
import Privacy from "../components/Privacy";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import Sparkles from "../components/Sparkles";
import StickyQuoteButton from "../components/StickyQuoteButton";
import { faqs } from "../mock";
const Home = () => {
  return (
    <div className="min-h-screen bg-cream">
      <SEO
        title="Premium House Cleaning in Brisbane | The Sterling Touch"
        description="Brisbane's premium residential cleaning service. Tailored, discreet and meticulous cleans across 20+ inner-city suburbs — Paddington, Ascot, Bulimba, Indooroopilly and more. Fully insured. Police checked."
        path="/"
        faqs={faqs}
      />
      <Sparkles />
      <StickyQuoteButton />
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Services />
        <WhyChooseUs />
        <Products />
        <Testimonials />
        <Privacy />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
